export function calculateAspectRatioAndOffset(srcWidth: number, srcHeight: number, maxWidth = 10, maxHeight = 10) {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  const width = srcWidth * ratio;
  const height = srcHeight * ratio;
  const y = (maxHeight - height) / 2 + maxHeight / 2;

  return { width, height, y };
}
